// extracted by mini-css-extract-plugin
export default {"black":"#000","white":"#fff","navMenuWrapper":"NavMenu_navMenuWrapper__3TYHE","navLink":"NavMenu_navLink__k6mII","navLinkActive":"NavMenu_navLinkActive__yZGSc"};